import {Injectable} from '@angular/core';
import {AppConfiguration} from './config.types';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AppConfigurationService {

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    ensureInit(): Promise<AppConfiguration> {
        return firstValueFrom(
            this._httpClient.get<AppConfiguration>(environment.configUrl)
        );
    }
}
